import { render, staticRenderFns } from "./CustomPayment-Ermunro.vue?vue&type=template&id=07defcb2&scoped=true&"
import script from "./CustomPayment-Ermunro.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-Ermunro.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-Ermunro.vue?vue&type=style&index=0&id=07defcb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07defcb2",
  null
  
)

export default component.exports